import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Button,
  Table,
  Card,
  Form,
  FormCheck,
  Collapse,
} from "react-bootstrap";

function ExcelDialog({ show, setShow, onDownload }) {
  const allFields = [
    "Project Name",
    "Project No",
    "Contract Vehicle",
    "KO name",
    "KO email",
    "KO phone",
    "KO address",
    "Published Date",
    "Due Date",
    "Project Description",
    "Organization Name",
    "Customer Name",
    "Customer Email",
    "Customer Phone",
    "Customer Address",
    "Shipping Method",
    "Sales Head Name",
    "Sales Head Email",
    "Sales Head Ph",
    "Shipping Terms",
    "Estimated Delivery",
    "Payment Terms", 
    "Shipping Cost($)",
    "Tax($)",
    // "Other Cost Name",
    "Other Cost",
    "Total Cost($)",
    "Total Price($)",
    "Created Date",
    "Last Updated Date",
    "Status",
    // "POC Name",
    // "POC Email",
    // "POC Phone",
    // "Price Change"
    // "Updated By",
    // add some new 
  ];

  const [selectedFields, setSelectedFields] = useState(allFields);
  const [pickFields, setPickFields] = useState(false);

  const handleFieldChange = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field)
        ? prev.filter((item) => item !== field)
        : [...prev, field]
    );
  };

  const handleAllFieldsToggle = () => {
    setPickFields(false);
    setSelectedFields(allFields);
  };

  const handlePickFieldsToggle = () => {
    setPickFields(true);
    setSelectedFields([]); // Reset selected fields
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      className="skusearch"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <Modal.Title>Excel Details </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="excel_checkbox">
            <FormCheck className="mb-2"
              type="checkbox"
              label="All Fields"
              checked={!pickFields}
              onChange={handleAllFieldsToggle}
            />
            <FormCheck className="mb-2"
              type="checkbox"
              label="Pick Fields"
              checked={pickFields}
              onChange={handlePickFieldsToggle}
            />
          </Form.Group>
          <Collapse in={pickFields}>
              <div className="excel_checkbox">
                {allFields.map((field) => (
                  <FormCheck
                    key={field}
                    type="checkbox"
                    label={field}
                    checked={selectedFields.includes(field)}
                    onChange={() => handleFieldChange(field)}
                  />
                ))}
              </div>
           
          </Collapse>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-warning" onClick={() => onDownload(selectedFields)}>DownLoad</Button>
       
      </Modal.Footer>
    </Modal>
  );
}

export default ExcelDialog;
